import { categories } from "@/mocks/categoryData";
import { toneIconClass } from "./tones";

export default function CategoryGrid() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-shell">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="text-sm text-accent-700 font-label">分类总览</span>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                按方向找站，比乱搜快得多
              </h2>
              <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
                26 个细分分类由人工逐条核对，每个方向只留下还能用、打开快的入口，方便你顺着一个目标一路挑下去。
              </p>
            </div>
            <span className="text-sm text-foreground-500 whitespace-nowrap">
              共 8 个主分类 · 每周更新
            </span>
          </div>

          <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.map((category) => (
              <a
                key={category.name}
                href="#sites"
                className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="flex items-center justify-between">
                  <span
                    className={`w-11 h-11 rounded-lg border flex items-center justify-center ${toneIconClass[category.tone]}`}
                  >
                    <i className={`${category.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs text-foreground-500">{category.count} 站</span>
                </span>
                <span className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {category.name}
                </span>
                <span className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {category.desc}
                </span>
                <span className="mt-4 flex flex-wrap gap-2">
                  {category.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-full bg-secondary-50 border border-secondary-200 text-xs text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}